<template>
    <div>
        <div class="search-bar">
            <div class="col-12 p-0">
                <input
                    class="form-control-lg search py-0"
                    v-model="searchQuery"
                    type="text"
                    :placeholder="'Zoeken binnen &quot;' + node + '&quot;....'"
                />
            </div>
        </div>
        <div class="results-count pt-4 pl-3" v-show="searchResults.length">
            <span id="resultsCountNumber">{{ searchResults.length }}</span>
            <span id="resultsText"> results</span>
        </div>
        <core-search-results-list
            v-if="searchResults.length"
            :results="searchResults"
            :linkPath="linkPath"
            :cols="cols"
            :linkType="itemLinkType"
        ></core-search-results-list>
    </div>
</template>

<script>
import Search from '@/services/hatsApi/Search'

export default {
  data () {
    return {
      searchQuery: '',
      searchResults: [],
      page: 1,
      itemLinkType: this.linkType
    }
  },
  props: {
    node: {
      type: String,
      required: true
    },
    searchField: {
      type: String,
      required: true
    },
    typeFilter: {
      default: null,
      type: Number,
      required: false
    },
    cols: {
      type: Array,
      required: false
    },
    linkPath: {
      type: String,
      required: false
    },
    limit: {
      default: 10,
      type: Number,
      required: false
    },
    linkType: {
      default: '',
      type: String,
      required: false
    }
  },
  watch: {
    // whenever searchQuery changes, this function will run
    searchQuery: function () {
      this.debouncedSearch()
    }
  },
  created: function () {
    this.debouncedSearch = this.$_.debounce(this.autoComplete, 500)
    this.initialSearch()
  },
  methods: {
    async initialSearch () {
      try {
        const response = await Search.search(this.node, [], this.limit, this.page, this.typeFilter)
        this.searchResults = response.data.data
      } catch (e) {
        console.log(e)
      }
    },
    async autoComplete () {
      if (this.searchQuery.length > 0) {
        try {
          let params = [
            {
              property: this.searchField,
              value: this.searchQuery
            }
          ]
          const response = await Search.search(this.node, params, this.limit, this.page, this.typeFilter)
          this.searchResults = response.data.data
        } catch (e) {
          console.log(e)
        }
      } else {
        this.initialSearch()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/core/Autocomplete.vue